import { useEffect, useState } from "react";

// EditableCell: displays an editable text value
interface PanelEditableCellProps {
    initialValue: string;
    onSave: (newValue: string) => void;
    width?: number;
    height?: number;
    editable?: boolean;
}

const PanelEditableCell: React.FC<PanelEditableCellProps> = ({ 
    initialValue,
    onSave,
    editable = true ,
    width,
    height,
}) => {
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    const handleBlur = () => {
        setEditing(false);
        if (value !== initialValue) {
            onSave(value);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            setEditing(false);
            if (value !== initialValue) {
                onSave(value);
            }
        }
        if (e.key === 'Escape') {
            setEditing(false);
            setValue(initialValue);
        }
    };

    const cellStyle = {
        width: width || '70px',
        height: height ? `${height}px` : undefined
    };

    if (!editable) {
        return (
            <span 
                className='sidepanel-readonly-cell'
                style={cellStyle}
            >
                {initialValue}
            </span>
        );
    }

    return editing ? (
        <input
            type="text"
            value={value}
            onChange={e => setValue(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            autoFocus
            className='sidepanel-editable-cell'
            style={cellStyle}
        />
    ) : (
        <span 
            className='sidepanel-editable-cell'
            style={cellStyle}
            onClick={() => setEditing(true)}
        >
            {value}
        </span>
    );
};

export default PanelEditableCell;